module.exports = __webpack_public_path__ + "img/full6-min.d2699e50.png";